import { actionCreation } from '@anna/anna-ws-utils';

const { generateActionTypes, makeActionCreator, generateActions } = actionCreation;

export const getAccountActionTypes = generateActionTypes('GET_ACCOUNT');

export const getAccountActions = generateActions(getAccountActionTypes, {
  success: ['data'],
});

export const updateSelectedAccountActionTypes = generateActionTypes('UPDATE_SELECTED_ACCOUNT');

export const updateSelectedAccountActions = generateActions(updateSelectedAccountActionTypes, {
  common: ['accountId'],
  success: ['account'],
});

export const accountChangedActionType = 'ON_ACCOUNT_CHANGED';

export const onAccountChangedAction = makeActionCreator(accountChangedActionType);
